<template>
    <footer>
      <div class="inner">
        <h1><router-link to="/"><img src="../assets/common/logo-footer.svg" alt="어썸멘토" /></router-link></h1>
        <div class="center">
          <ul>
            <li><a href="javascript:" @click="showPolicy(1)">개인정보처리방침</a></li>
            <li><a href="javascript:" @click="showPolicy(2)">이용약관</a></li>
            <li><a href="javascript:" @click="showPolicy(3)">환불정책</a></li>
            <li><router-link to="/membership">멤버십 구독하기</router-link></li>
          </ul>
          <div>
            <p>
              <span>(주)인사이트컨설팅</span>
              <span>대표자 : 이연하</span>
              <span>서울특별시 강남구 논현로 135길 10 B1</span>
            </p>
            <p>
              <span>사업자등록번호 : 211-88-97516</span>
              <span>대표메일 : <a href="mailto:awesomentor2020@gmail.com">awesomentor2020@gmail.com</a></span>
              <span>대표번호 : 02-6433-5734</span>
            </p>
          </div>
          <p>AwesomeMentor © 2022 Copyright</p>
        </div>
        <div class="right">
          <select class="en">
            <option value="">Family Site</option>
          </select>
        </div>
      </div>

      <ul id="quick">
        <li v-if="is_activity">
          <a href="javascript:" @click="editActivity"><img src="@/assets/common/btn-fixed-modify.svg" alt="modify"></a>
          <dl>
            <dt>활동 수정 요청하기</dt>
            <dd>잘못된 활동 정보를 수정 요청 할 수 있습니다. <br>수정 요청 후 승인이 되면 활동 포인트가 2배!</dd>
          </dl>
        </li>
        <li v-if="is_activity">
          <a href="javascript:;" @click="addActivity"><img src="@/assets/common/btn-fixed-add.svg" alt="add"></a>
          <dl>
            <dt>활동 만들기</dt>
            <dd>어썸멘토 회원이라면 누구나 만들 수 있습니다.<br>(활동 추가 시 2,000포인트 증정)</dd>
          </dl>
        </li>
        <li><a href="javascript:" @click="showPopup=true; popupContents=5;"><img src="@/assets/common/btn-fixed-point.svg" alt="TOP"></a></li>
        <li><a href="javascript:" @click="scrollToTop()"><img src="@/assets/common/btn-top.svg" alt="TOP"></a></li>
      </ul>
      <ModalPolicy ref="policyModal"></ModalPolicy>
      <transition name="fade" mode="out-in">
          <div class="popup_wrap" v-if="showPopup===true">
            <div class="black" @click="showPopup=false"></div>
<!--            <div class="inner w_640" v-if="popupContents==1">-->
<!--              <div class="head">-->
<!--                <p>개인정보처리방침</p>-->
<!--                <a href="javascript:" class="btn_close" @click="showPopup=false"><img src="../assets/common/ico-24-close.svg" alt="닫기"></a>-->
<!--              </div>-->
<!--              <div class="body full">-->
<!--                <p>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다.</p>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="inner w_640" v-if="popupContents==2">-->
<!--              <div class="head">-->
<!--                <p>이용약관</p>-->
<!--                <a href="javascript:" class="btn_close" @click="showPopup=false"><img src="../assets/common/ico-24-close.svg" alt="닫기"></a>-->
<!--              </div>-->
<!--              <div class="body full">-->
<!--                <p>제 1조 목적 이 이용약관(이하”약관”이라 합니다.)은 (주)인사이트컨설팅이 제공하는 유학컨설팅 관련 제반 서비스(이하 “서비스”라 한다.)를 이용고객(“회원”이라 합니다.) 이 이용함에 있어 회사와 회원간의 권리, 의무, 기타 필요한 사항을 규정함을 목적으로 합니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다.</p>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="inner w_640" v-if="popupContents==3">-->
<!--              <div class="head">-->
<!--                <p>환불정책</p>-->
<!--                <a href="javascript:" class="btn_close" @click="showPopup=false"><img src="../assets/common/ico-24-close.svg" alt="닫기"></a>-->
<!--              </div>-->
<!--              <div class="body full">-->
<!--                <p>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다. <br><br>&lt;어썸멘토&gt;은(는) ｢개인정보 보호법｣ 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. <br><br>제1조(개인정보의 처리목적) &lt;어썸멘토&gt;은(는) 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 ｢개인정보 보호법｣ 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br><br>1. 홈페이지 회원 가입 및 관리 <br>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 각종 고지· 통지, 고충처리 목적으로 개인정보를 처리합니다. <br><br>2. 재화 또는 서비스 제공 <br>물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심을 목적으로 개인정보를 처리합니다.</p>-->
<!--              </div>-->
<!--            </div>-->

            <div class="inner w_640" v-if="popupContents==4">
              <div class="head">
                <p>활동 수정 요청</p>
                <a href="javascript:" class="btn_close" @click="showPopup=false"><img src="@/assets/common/ico-24-close.svg" alt="닫기"></a>
              </div>
              <div class="body">
                <form>
                  <div class="form_wrap">
                    <div class="row">
                      <label for="input_01">이메일</label>
                      <div class="input_wrap">
                        <input id="input_01" type="text" v-model="report.email" readonly>
                      </div>
                    </div>
                    <div class="row">
                      <div class="select_wrap">
                        <DropDown v-model="selectedSubjects" :options="subjects" optionLabel="activity_name" :filter="true" placeholder="활동 이름을 선택하세요." :showClear="true">
                          <template #value="slotProps">
                            <div v-if="slotProps.value">
                              <div>{{slotProps.value.activity_name}}</div>
                            </div>
                            <span v-else>
                        {{slotProps.placeholder}}
                      </span>
                          </template>
                          <template #option="slotProps">
                            <div>
                              <div>{{slotProps.option.activity_name}}</div>
                            </div>
                          </template>
                        </DropDown>
                      </div>
                      <div class="alert" v-if="validSubject">활동이름을 선택하셔야 합니다.</div>
                    </div>
                    <div class="row">
                      <div class="textarea">
                        <TextEditor ref="textEditor" :editor-style="'height: 400px'"></TextEditor>
                      </div>
                      <div class="alert" v-if="validReportContent">내용을 입력하셔야 합니다.</div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="foot">
                <a href="javascript:" @click="goReportLink">등록하기</a>
              </div>
            </div>

            <div class="inner point" v-if="popupContents==5">
              <div class="head">
                <p>포인트 안내</p>
                <a href="javascript:" class="btn_close" @click="showPopup=false"><img src="@/assets/common/ico-24-close.svg" alt="닫기"></a>
              </div>
              <div class="body full">
                <img src="@/assets/common/point-pop-txt.png">
              </div>
            </div>
          </div>
      </transition>
      <ConfirmDialog></ConfirmDialog>
    </footer>
</template>

<script>
import store from "@/store";
import ModalPolicy from "@/components/ModalPolicy";
import TextEditor from "@/components/TextEditor";
import {getData, postData} from "@/api/serverApi";

export default {
  name: "AppFooter",
  components: {
    ModalPolicy,
    TextEditor,
  },
  data() {
    return {
      CurrentRoute: this.$route.path,
      showPopup: false,
      popupContents: 1,
      selectedSubjects: null,
      loading: false,
      is_activity: false,
      validSubject: false,
      validReportContent: false,
      userInfo: {},
      report: {},
      subjects: [
        {name: "서울대학교 수의학과 '고교생 수의학 아카데미'"},
        {name: "서울 수의과대학 '고교생 수의학 아카데미'"},
        {name: "2021 서울대학교 수의과대학 '고교생 수의학 아카데미'"},
        {name: "서울랜드"},
        {name: "2022 서울대학교 수의과대학 '고교생 수의학 아카데미'"},
        {name: "고려대학교 수의학과 '고교생 수의학 아카데미'"},
        {name: "연세대학교 수의학과 '고교생 수의학 아카데미'"},
      ],
      items: Array.from({ length: 100000 }, (_, i) => ({ label: `Item #${i}`, value: i })),
      lazyItems: Array.from({ length: 100000 }),
      loadLazyTimeout: null,
    }
  },
  mounted() {
    if (this.$route.path.indexOf('activity') > -1) {
      this.is_activity = true
    } else {
      this.is_activity = false
    }
  },
  methods: {
    pleaseLogin() {
      this.$confirm.require({
        message: '로그인 후 이용해주세요.',
        header: '확인',
        acceptLabel: '확인',
        rejectClass: 'd-none',
        accept: () => {
          //callback to execute when user confirms the action
        }
      });
    },
    addActivity() {
      this.$log.debug(['addActivity', this.$cookies.get('accessToken'), store.getters["auth/getAccessToken"]])
      if (this.$cookies.get('accessToken')) {
        this.$router.push('/activity/add');
      } else {
        // message
        this.pleaseLogin();
      }
    },
    async editActivity() {
      if (this.$cookies.get('accessToken')) {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        // 활동 전체 데이터 가져오기.
        const res = await getData('/activity/all');
        this.$log.debug(['res', res.data]);
        this.report.email = this.userInfo.email;
        if (res) {
          this.subjects = res.data;
          this.selectedSubjects = this.activity;
          this.showPopup=true;
          this.popupContents=4;
        }

      } else {
        // message
        this.pleaseLogin();
      }
    },
    scrollToTop() {
      window.scrollTo({top:0,behavior:'smooth'});
    },
    onLazyLoad(event) {
      this.loading = true;

      if (this.loadLazyTimeout) {
        clearTimeout(this.loadLazyTimeout);
      }

      //imitate delay of a backend call
      this.loadLazyTimeout = setTimeout(() => {
        const { first, last } = event;
        const lazyItems = [...this.lazyItems];

        for (let i = first; i < last; i++) {
          lazyItems[i] = { label: `Item #${i}`, value: i };
        }

        this.lazyItems = lazyItems;
        this.loading = false;
      }, Math.random() * 1000 + 250);
    },
    showPolicy(val) {
      this.$refs.policyModal.popupContents = val;
      this.$refs.policyModal.showPopup = true;

    },
    async goReportLink() {
      this.$log.debug(['goReportLink', this.selectedSubjects, this.$refs.textEditor.$refs.myQuillEditor.getHTML()])

      if (this.$cookies.get('accessToken')) {
        if (!this.selectedSubjects) {
          this.validSubject = true;
          return;
        } else {
          this.validSubject = false;
        }

        if (!this.$refs.textEditor.$refs.myQuillEditor.getHTML() || this.$refs.textEditor.$refs.myQuillEditor.getHTML() === '<p><br></p>') {
          this.validReportContent = true;
          return;
        } else {
          this.validReportContent = false;
        }

        this.report.user_name = this.userInfo.user_name;
        this.report.activity_code = this.selectedSubjects.activity_code;
        this.report.activity_name = this.selectedSubjects.activity_name;
        this.report.content = this.$refs.textEditor.$refs.myQuillEditor.getHTML();

        const res = await postData('/activity/report', this.report);

        if (res.data.success) {
          this.$toast.add({severity:'success', detail: '활동 수정 요청이 완료되었습니다.', life: 2000});
        } else {
          this.$toast.add({severity:'error', detail: '활동 수정 요청이 실패하였습니다.', life: 2000});
        }

        this.showPopup = false;
        this.report = {};
        this.selectedSubjects = null;
        this.$refs.textEditor.$refs.myQuillEditor.setHTML('');

      } else {
        this.$toast.add({severity:'error', detail: '로그인 후 이용가능합니다.', life: 2000});
      }


    },
  },
  watch: {
    showPopup: function(){
      if (this.showPopup) {
        document.documentElement.style.overflow = 'hidden';
        return;
      } document.documentElement.style.overflow = 'auto';
    },
    $route(to, from) {
      if (to.path.indexOf('activity') > -1) {
        this.is_activity = true;
      } else {
        this.is_activity = false;
      }
      if (to.path != from.path) {
        document.documentElement.style.overflow = 'auto';
      }
    }
  },
}
</script>

<style scoped>
</style>
